export default __webpack_public_path__ + "static/media/login-slide-3.f091eb73.svg";